import { useMatches } from 'react-router';
import { useHeaderTitleOverride } from '@/shared/navigation';
import { pickRouteTitle, type RouteTitleHandle } from '@/shared/routing';

/**
 * 현재 매치 체인의 타이틀 핸들을 읽는다(모바일 셸 헤더·데스크탑 페이지 헤더 공용). 화면이 동적 타이틀
 * (`useSetHeaderTitle`, 예: 발전소 상세=이름)을 설정했으면 그 값이 handle.title 을 덮어쓴다(isSubpage 는 handle 유지).
 *
 * 선택 규칙 자체는 `shared/routing` 의 `pickRouteTitle` 이 소유한다 — `document.title` 배선(트리 밖)과
 * **같은 규칙**을 써야 헤더와 브라우저 탭 제목이 어긋나지 않는다.
 */
export function useRouteTitle(): RouteTitleHandle {
  const override = useHeaderTitleOverride();
  const handle = pickRouteTitle(useMatches());
  if (override) return { ...handle, title: override };
  return handle;
}
